import {escapeRegExp} from './StringUtils';
import {isEmpty} from './ValidationUtils';

export const keepDecimalCharacters = (val: string = '', decimalSeparator: string = '.') => {
    const numRegex = new RegExp(`\\d|${escapeRegExp(decimalSeparator)}`, 'g');
    return (val.match(numRegex) || []).join('').replace(decimalSeparator, '.');
};

export const keepOnlyNumberCharacters = (val: string = '') => {
    const numRegex = new RegExp('\\d', 'g');
    return (val.match(numRegex) || []).join('');
};

export const keepOnlyAlphaNumericCharacters = (val: string = '') => {
    // tslint:disable-next-line: prefer-template
    const numRegex = new RegExp('[A-Za-z0-9]', 'g');
    return (val.match(numRegex) || []).join('');
};

export const splitDecimal = (number: string) => {
    const parts = number.split('.');
    const integerPart = parts[0];
    const fractionalPart = parts[1] || '';
    return {
        integerPart,
        fractionalPart
    };
};

export const limitLength = (number: string, length: number) => {
    let str = '';
    for (let i = 0; i <= length - 1; i = i + 1) {
        str += number[i] || '';
    }
    return str;
};

export const formatDecimalNumber = (num: string = '', maxDecimals: number = 2, decimalSeparator: string = '.') => {
    if (isEmpty(num)) return num;

    let float = String(keepDecimalCharacters(num, decimalSeparator));

    if (decimalSeparator && maxDecimals === 0) {
        float = float.split(decimalSeparator)[0];
    }

    float = float.charAt(0) === '.' ? `0.${float.substring(1)}` : float;

    const removeExtraDecimalSeparators = float.split('.');
    float = removeExtraDecimalSeparators.length > 1 ?
        (`${removeExtraDecimalSeparators.shift()}.${removeExtraDecimalSeparators.join('')}`) : float;

    // eslint-disable-next-line prefer-const
    let {integerPart, fractionalPart} = splitDecimal(float);

    if (maxDecimals !== undefined) {
        fractionalPart = limitLength(fractionalPart, maxDecimals);
    }

    const hasDecimalSeparator = float.indexOf('.') !== -1;

    return integerPart + (hasDecimalSeparator && decimalSeparator || '') + fractionalPart;
};
